const CloseXIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.3648 5.05093L14.9506 3.63672L10.0004 8.58691L5.05093 3.63746L3.63672 5.05168L8.58617 10.0011L3.63687 14.9504L5.05108 16.3646L10.0004 11.4153L14.9504 16.3654L16.3646 14.9512L11.4146 10.0011L16.3648 5.05093Z" fill="white" />
  </svg>


);
const DownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.19995 11.1998V11.1673L2.3431 6.31043L3.47447 5.17906L7.19995 8.90454V0.799805H8.79995V8.90454L12.5254 5.17906L13.6568 6.31043L8.79995 11.1673V11.1998H8.76743L7.99995 11.9673L7.23247 11.1998H7.19995Z" fill="white" />
    <path d="M1.19995 13.1719V14.7719H14.8V13.1719H1.19995Z" fill="white" />
  </svg>
);

const KeywordIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.8416 5.26677C1.06427 6.05047 0.435618 6.98187 0.00146484 8.01514C1.30365 11.1556 4.39917 13.3646 8.01061 13.3646C8.61071 13.3646 9.19656 13.3036 9.76231 13.1875L8.33223 11.7574C8.22562 11.7622 8.11839 11.7646 8.01061 11.7646C5.3106 11.7646 2.96117 10.25 1.77112 8.0193C2.09351 7.42176 2.49929 6.87616 2.97279 6.39795L1.8416 5.26677ZM13.0328 9.66975C13.5063 9.19155 13.9121 8.64594 14.2345 8.04841C13.0444 5.81771 10.695 4.30313 7.99499 4.30313C7.88721 4.30313 7.77999 4.30554 7.67337 4.31031L6.2433 2.88024C6.80904 2.76412 7.39489 2.70312 7.99499 2.70312C11.6064 2.70312 14.702 4.91208 16.0041 8.05257C15.57 9.08584 14.9413 10.0172 14.164 10.8009L13.0328 9.66975Z" fill="#989FB3" />
    <path d="M14 14.0313L2 2.03125" stroke="#989FB3" strokeWidth="1.6" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.53748 6.70703C5.32419 7.10221 5.20312 7.55449 5.20312 8.03505C5.20312 9.58145 6.45673 10.8351 8.00312 10.8351C8.48369 10.8351 8.93597 10.714 9.33115 10.5007L8.06399 9.23354C8.04383 9.23454 8.02354 9.23505 8.00312 9.23505C7.34038 9.23505 6.80313 8.69779 6.80313 8.03505C6.80313 8.01464 6.80363 7.99435 6.80464 7.97419L5.53748 6.70703Z" fill="#989FB3" />
  </svg>

);

const NokeywordIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_8295_3757" fill="white">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.00146482 7.97762C1.31042 4.85204 4.39824 2.65625 7.99891 2.65625C11.6068 2.65625 14.6997 4.86082 16.0042 7.99634C14.6952 11.1219 11.6074 13.3177 8.00673 13.3177C4.39887 13.3177 1.30591 11.1131 0.00146482 7.97762Z" />
    </mask>
    <path d="M0.00146482 7.97762L-1.47434 7.35957L-1.73232 7.97558L-1.4758 8.59219L0.00146482 7.97762ZM16.0042 7.99634L17.48 8.61439L17.738 7.99838L17.4814 7.38176L16.0042 7.99634ZM1.47727 8.59567C2.54589 6.04399 5.06549 4.25625 7.99891 4.25625V1.05625C3.73099 1.05625 0.0749529 3.66009 -1.47434 7.35957L1.47727 8.59567ZM7.99891 4.25625C10.9382 4.25625 13.462 6.05116 14.5269 8.61091L17.4814 7.38176C15.9375 3.67047 12.2753 1.05625 7.99891 1.05625V4.25625ZM14.5284 7.37829C13.4598 9.92996 10.9402 11.7177 8.00673 11.7177V14.9177C12.2746 14.9177 15.9307 12.3139 17.48 8.61439L14.5284 7.37829ZM8.00673 11.7177C5.06745 11.7177 2.54364 9.9228 1.47873 7.36305L-1.4758 8.59219C0.0681876 12.3035 3.73029 14.9177 8.00673 14.9177V11.7177Z" fill="#989FB3" mask="url(#path-1-inside-1_8295_3757)" />
    <circle cx="7.99922" cy="8.00313" r="2" stroke="#989FB3" strokeWidth="1.6" />
  </svg>

);

const LastIconDisable = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.5 15.9999C31.5 24.5602 24.5604 31.4997 16 31.4997C7.43958 31.4997 0.499998 24.5602 0.499998 15.9999C0.499998 7.43953 7.43958 0.499998 16 0.499998C24.5604 0.499998 31.5 7.43953 31.5 15.9999Z" fill="black" fillOpacity="0.6" stroke="#606880" strokeWidth="0.999996" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.9699 16L19.1521 11.8178L17.7379 10.4036L12.1414 16L17.7379 21.5965L19.1521 20.1822L14.9699 16Z" fill="#606880" />
  </svg>
);
const LastIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.5 15.9999C31.5 24.5602 24.5604 31.4997 16 31.4997C7.43958 31.4997 0.499998 24.5602 0.499998 15.9999C0.499998 7.43953 7.43958 0.499998 16 0.499998C24.5604 0.499998 31.5 7.43953 31.5 15.9999Z" fill="black" fillOpacity="0.6" stroke="white" strokeWidth="0.999996" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.9702 16L19.1524 11.8178L17.7382 10.4036L12.1417 16L17.7382 21.5965L19.1524 20.1822L14.9702 16Z" fill="white" />
  </svg>
);

const NextIconDisable = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.499998 15.9999C0.499998 24.5602 7.43958 31.4997 16 31.4997C24.5604 31.4997 31.5 24.5602 31.5 15.9999C31.5 7.43953 24.5604 0.499998 16 0.499998C7.43958 0.499998 0.499998 7.43953 0.499998 15.9999Z" fill="black" fillOpacity="0.6" stroke="#606880" strokeWidth="0.999996" />
    <path fillRule="evenodd" clipRule="evenodd" d="M17.0298 16L12.8476 11.8178L14.2618 10.4036L19.8583 16L14.2618 21.5965L12.8476 20.1822L17.0298 16Z" fill="#606880" />
  </svg>
);

const NextIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.499998 15.9999C0.499998 24.5602 7.43958 31.4997 16 31.4997C24.5604 31.4997 31.5 24.5602 31.5 15.9999C31.5 7.43953 24.5604 0.499998 16 0.499998C7.43958 0.499998 0.499998 7.43953 0.499998 15.9999Z" fill="black" fillOpacity="0.6" stroke="white" strokeWidth="0.999996" />
    <path fillRule="evenodd" clipRule="evenodd" d="M17.0298 16L12.8476 11.8178L14.2618 10.4036L19.8583 16L14.2618 21.5965L12.8476 20.1822L17.0298 16Z" fill="white" />
  </svg>
);

const ShareTopRightIcon = () => (
  // <svg
  //   width="31"
  //   height="31"
  //   viewBox="0 0 31 31"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <g filter="url(#filter0_ii_571_3115)">
  //     <circle cx="17" cy="17" r="14" fill="url(#paint0_radial_571_3115)" />
  //   </g>
  //   <g filter="url(#filter1_f_571_3115)">
  //     <circle
  //       cx="12.3336"
  //       cy="12.3336"
  //       r="6.22222"
  //       fill="url(#paint1_radial_571_3115)"
  //     />
  //   </g>
  //   <defs>
  //     <filter
  //       id="filter0_ii_571_3115"
  //       x="3"
  //       y="-1"
  //       width="28"
  //       height="34"
  //       filterUnits="userSpaceOnUse"
  //       colorInterpolationFilters="sRGB"
  //     >
  //       <feFlood floodOpacity="0" result="BackgroundImageFix" />
  //       <feBlend
  //         mode="normal"
  //         in="SourceGraphic"
  //         in2="BackgroundImageFix"
  //         result="shape"
  //       />
  //       <feColorMatrix
  //         in="SourceAlpha"
  //         type="matrix"
  //         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  //         result="hardAlpha"
  //       />
  //       <feMorphology
  //         radius="2"
  //         operator="erode"
  //         in="SourceAlpha"
  //         result="effect1_innerShadow_571_3115"
  //       />
  //       <feOffset dy="2" />
  //       <feGaussianBlur stdDeviation="3" />
  //       <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
  //       <feColorMatrix
  //         type="matrix"
  //         values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  //       />
  //       <feBlend
  //         mode="normal"
  //         in2="shape"
  //         result="effect1_innerShadow_571_3115"
  //       />
  //       <feColorMatrix
  //         in="SourceAlpha"
  //         type="matrix"
  //         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  //         result="hardAlpha"
  //       />
  //       <feOffset dy="-4" />
  //       <feGaussianBlur stdDeviation="2" />
  //       <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
  //       <feColorMatrix
  //         type="matrix"
  //         values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  //       />
  //       <feBlend
  //         mode="normal"
  //         in2="effect1_innerShadow_571_3115"
  //         result="effect2_innerShadow_571_3115"
  //       />
  //     </filter>
  //     <filter
  //       id="filter1_f_571_3115"
  //       x="0.111328"
  //       y="0.111328"
  //       width="24.4443"
  //       height="24.4443"
  //       filterUnits="userSpaceOnUse"
  //       colorInterpolationFilters="sRGB"
  //     >
  //       <feFlood floodOpacity="0" result="BackgroundImageFix" />
  //       <feBlend
  //         mode="normal"
  //         in="SourceGraphic"
  //         in2="BackgroundImageFix"
  //         result="shape"
  //       />
  //       <feGaussianBlur
  //         stdDeviation="3"
  //         result="effect1_foregroundBlur_571_3115"
  //       />
  //     </filter>
  //     <radialGradient
  //       id="paint0_radial_571_3115"
  //       cx="0"
  //       cy="0"
  //       r="1"
  //       gradientUnits="userSpaceOnUse"
  //       gradientTransform="translate(12.3333 10) rotate(60.1011) scale(17.9438 67.8429)"
  //     >
  //       <stop stopColor="#AAF9DF" />
  //       <stop offset="1" stopColor="#71FFD0" />
  //     </radialGradient>
  //     <radialGradient
  //       id="paint1_radial_571_3115"
  //       cx="0"
  //       cy="0"
  //       r="1"
  //       gradientUnits="userSpaceOnUse"
  //       gradientTransform="translate(12.3335 11.1669) rotate(90) scale(14.3889)"
  //     >
  //       <stop stopColor="white" />
  //       <stop offset="1" stopColor="white" stopOpacity="0" />
  //     </radialGradient>
  //   </defs>
  // </svg>
  <svg width="52" height="51" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_di_6181_6658)">
      <circle cx="26.2745" cy="26.2745" r="20.4557" transform="rotate(-171.434 26.2745 26.2745)" fill="url(#paint0_radial_6181_6658)" />
      <circle cx="26.2745" cy="26.2745" r="20.4557" transform="rotate(-171.434 26.2745 26.2745)" fill="url(#paint1_linear_6181_6658)" fillOpacity="0.25" />
    </g>
    <defs>
      <filter id="filter0_di_6181_6658" x="0.176833" y="0.233292" width="51.0928" height="50.3385" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="-0.174472" dy="-0.872361" />
        <feGaussianBlur stdDeviation="2.35538" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.434861 0 0 0 0 0.534122 0 0 0 0 0.841667 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6181_6658" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6181_6658" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="-7.37483" />
        <feGaussianBlur stdDeviation="2.81979" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.39 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_6181_6658" />
      </filter>
      <radialGradient id="paint0_radial_6181_6658" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(39.3346 42.5603) rotate(-130.018) scale(65.0257 60.0762)">
        <stop stopColor="#6486FF" />
        <stop offset="0.276042" stopColor="#666CFA" />
        <stop offset="0.630208" stopColor="#2F009A" />
        <stop offset="0.963542" stopColor="#001843" />
      </radialGradient>
      <linearGradient id="paint1_linear_6181_6658" x1="11.134" y1="41.8813" x2="40.0887" y2="42.2804" gradientUnits="userSpaceOnUse">
        <stop offset="0.31118" stopColor="#5932B1" />
        <stop offset="0.708333" stopColor="#668FFA" />
        <stop offset="0.961295" stopColor="#B1D7ED" />
      </linearGradient>
    </defs>
  </svg>

);
const ShareLeftBottomIcon = () => (
  // <svg
  //   width="26"
  //   height="26"
  //   viewBox="0 0 26 26"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <g filter="url(#filter0_ii_571_3118)">
  //     <circle cx="15" cy="15" r="11" fill="url(#paint0_radial_571_3118)" />
  //   </g>
  //   <g filter="url(#filter1_f_571_3118)">
  //     <circle
  //       cx="11.3332"
  //       cy="11.3332"
  //       r="4.88889"
  //       fill="url(#paint1_radial_571_3118)"
  //     />
  //   </g>
  //   <defs>
  //     <filter
  //       id="filter0_ii_571_3118"
  //       x="4"
  //       y="0"
  //       width="22"
  //       height="28"
  //       filterUnits="userSpaceOnUse"
  //       colorInterpolationFilters="sRGB"
  //     >
  //       <feFlood floodOpacity="0" result="BackgroundImageFix" />
  //       <feBlend
  //         mode="normal"
  //         in="SourceGraphic"
  //         in2="BackgroundImageFix"
  //         result="shape"
  //       />
  //       <feColorMatrix
  //         in="SourceAlpha"
  //         type="matrix"
  //         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  //         result="hardAlpha"
  //       />
  //       <feMorphology
  //         radius="2"
  //         operator="erode"
  //         in="SourceAlpha"
  //         result="effect1_innerShadow_571_3118"
  //       />
  //       <feOffset dy="2" />
  //       <feGaussianBlur stdDeviation="3" />
  //       <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
  //       <feColorMatrix
  //         type="matrix"
  //         values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  //       />
  //       <feBlend
  //         mode="normal"
  //         in2="shape"
  //         result="effect1_innerShadow_571_3118"
  //       />
  //       <feColorMatrix
  //         in="SourceAlpha"
  //         type="matrix"
  //         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  //         result="hardAlpha"
  //       />
  //       <feOffset dy="-4" />
  //       <feGaussianBlur stdDeviation="2" />
  //       <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
  //       <feColorMatrix
  //         type="matrix"
  //         values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  //       />
  //       <feBlend
  //         mode="normal"
  //         in2="effect1_innerShadow_571_3118"
  //         result="effect2_innerShadow_571_3118"
  //       />
  //     </filter>
  //     <filter
  //       id="filter1_f_571_3118"
  //       x="0.444336"
  //       y="0.444336"
  //       width="21.7778"
  //       height="21.7773"
  //       filterUnits="userSpaceOnUse"
  //       colorInterpolationFilters="sRGB"
  //     >
  //       <feFlood floodOpacity="0" result="BackgroundImageFix" />
  //       <feBlend
  //         mode="normal"
  //         in="SourceGraphic"
  //         in2="BackgroundImageFix"
  //         result="shape"
  //       />
  //       <feGaussianBlur
  //         stdDeviation="3"
  //         result="effect1_foregroundBlur_571_3118"
  //       />
  //     </filter>
  //     <radialGradient
  //       id="paint0_radial_571_3118"
  //       cx="0"
  //       cy="0"
  //       r="1"
  //       gradientUnits="userSpaceOnUse"
  //       gradientTransform="translate(11.3333 9.5) rotate(60.1011) scale(14.0987 53.3051)"
  //     >
  //       <stop offset="0.114583" stopColor="#CCFFFF" />
  //       <stop offset="1" stopColor="#7DFFFF" />
  //     </radialGradient>
  //     <radialGradient
  //       id="paint1_radial_571_3118"
  //       cx="0"
  //       cy="0"
  //       r="1"
  //       gradientUnits="userSpaceOnUse"
  //       gradientTransform="translate(11.3332 10.4166) rotate(90) scale(11.3056)"
  //     >
  //       <stop stopColor="white" />
  //       <stop offset="1" stopColor="white" stopOpacity="0" />
  //     </radialGradient>
  //   </defs>
  // </svg>
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_6158_35463)">
      <circle cx="13.4648" cy="14.4647" r="8.31871" transform="rotate(-171.434 13.4648 14.4647)" fill="url(#paint0_radial_6158_35463)" />
    </g>
    <defs>
      <filter id="filter0_d_6158_35463" x="0.259795" y="0.561417" width="26.0612" height="26.0612" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="-0.174472" dy="-0.872361" />
        <feGaussianBlur stdDeviation="2.35538" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.946333 0 0 0 0 0.883333 0 0 0 0.62 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6158_35463" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6158_35463" result="shape" />
      </filter>
      <radialGradient id="paint0_radial_6158_35463" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.6687 19.5782) rotate(-143.573) scale(16.3597 22.6385)">
        <stop stopColor="white" />
        <stop offset="0.402595" stopColor="#FEFFD5" />
        <stop offset="1" stopColor="#C78625" />
      </radialGradient>
    </defs>
  </svg>

);
const ShareButtonIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ii_571_3121)">
      <circle cx="13.5" cy="13.5" r="9.5" fill="url(#paint0_radial_571_3121)" />
    </g>
    <g filter="url(#filter1_f_571_3121)">
      <circle
        cx="10.3336"
        cy="10.3336"
        r="4.22222"
        fill="url(#paint1_radial_571_3121)"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_571_3121"
        x="4"
        y="0"
        width="19"
        height="25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="2"
          operator="erode"
          in="SourceAlpha"
          result="effect1_innerShadow_571_3121"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_571_3121"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_571_3121"
          result="effect2_innerShadow_571_3121"
        />
      </filter>
      <filter
        id="filter1_f_571_3121"
        x="0.111328"
        y="0.111328"
        width="20.4443"
        height="20.4443"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="3"
          result="effect1_foregroundBlur_571_3121"
        />
      </filter>
      <radialGradient
        id="paint0_radial_571_3121"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.3333 8.75) rotate(60.1011) scale(12.1761 46.0363)"
      >
        <stop offset="0.307292" stopColor="#C9F5FF" />
        <stop offset="1" stopColor="#84CBFF" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_571_3121"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.3336 9.54188) rotate(90) scale(9.76389)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

const CloseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3648 5.05093L14.9506 3.63672L10.0004 8.58691L5.05093 3.63746L3.63672 5.05168L8.58617 10.0011L3.63687 14.9504L5.05108 16.3646L10.0004 11.4153L14.9504 16.3654L16.3646 14.9512L11.4146 10.0011L16.3648 5.05093Z"
      fill="#ADB5CC"
    />
  </svg>
);

const LogoIcon =
  () => `<svg width="105" height="25" viewBox="0 0 105 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M86.9238 19.9024H89.9057V8.44336H86.9238V19.9024Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M86.9238 7.13464H89.9057V4.15625H86.9238V7.13464Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M82.3721 19.9051H85.354V16.9268H82.3721V19.9051Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M61.2829 18.3498C61.4566 18.811 61.7218 19.1719 62.0373 19.454C62.3569 19.74 62.732 19.963 63.1766 20.0896C63.6284 20.2162 64.1269 20.2657 64.6539 20.2657C65.1993 20.2657 65.6855 20.2091 66.1005 20.0972C66.4858 19.9939 66.8551 19.8476 67.1987 19.662V17.5572C66.6521 17.7932 66.1411 17.8788 65.5582 17.906C64.9427 17.9345 64.5786 17.7588 64.2755 17.4707C63.9581 17.1687 63.7889 16.7748 63.7889 16.1142V9.74849H67.1987V7.13659H63.7889V4.1582H61.0182V7.13659H59.3574V9.74849H61.0182V16.5839C61.0182 17.2899 61.1069 17.8838 61.2829 18.3498Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M43.3083 11.0122H35.8833V14.092H40.0527C39.8349 14.9718 39.4046 15.7605 38.7876 16.3905C37.8565 17.3408 36.5657 17.8641 35.1528 17.8641C32.2201 17.8641 29.8344 15.4812 29.8344 12.5521C29.8344 9.62306 32.2201 7.23997 35.1528 7.23997C36.7234 7.23997 38.1673 7.91125 39.1683 9.06936L41.5556 7.12101C39.9727 5.26859 37.6244 4.16016 35.1528 4.16016C30.5199 4.16016 26.751 7.92483 26.751 12.5521C26.751 17.1794 30.5199 20.9439 35.1528 20.9439C37.4018 20.9439 39.4753 20.1344 40.9912 18.5873C42.2634 17.2887 43.1066 15.477 43.2687 13.6623C43.3477 12.7768 43.3547 11.8979 43.3083 11.0122Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M74.8185 9.51363C76.5294 9.51363 77.9883 10.5877 78.5583 12.0973H71.0787C71.6487 10.5877 73.1076 9.51363 74.8185 9.51363ZM81.5124 14.5325C81.5636 14.1978 81.5901 13.855 81.5901 13.5062C81.5901 9.77216 78.559 6.74512 74.8198 6.74512C71.0821 6.74512 68.0508 9.77216 68.0508 13.5062C68.0508 17.2403 71.0821 20.2672 74.8198 20.2672C77.3847 20.2672 79.6162 18.8426 80.765 16.7428L78.2636 15.5307C77.5685 16.7078 76.2868 17.4978 74.8198 17.4978C72.9664 17.4978 71.4082 16.2374 70.9561 14.528H78.6832C78.6829 14.5294 78.6825 14.5309 78.6822 14.5325H81.5124Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M51.0749 17.4959C48.8677 17.4959 47.0781 15.7086 47.0781 13.5038C47.0781 11.299 48.8677 9.51172 51.0749 9.51172C53.2823 9.51172 55.0717 11.299 55.0717 13.5038C55.0717 15.7086 53.2823 17.4959 51.0749 17.4959ZM51.0746 6.75488C47.3367 6.75488 44.3066 9.78158 44.3066 13.515C44.3066 17.2485 47.3367 20.2752 51.0746 20.2752C54.8126 20.2752 57.8426 17.2485 57.8426 13.515C57.8426 9.78158 54.8126 6.75488 51.0746 6.75488Z" fill="white"/>
  <mask id="mask0_6141_33380" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="105" height="25">
  <path fillRule="evenodd" clipRule="evenodd" d="M0 24.0116H105V0H0V24.0116Z" fill="white"/>
  </mask>
  <g mask="url(#mask0_6141_33380)">
  <path fillRule="evenodd" clipRule="evenodd" d="M55.0698 19.9031H57.8405V7.12402H55.0698V19.9031Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M98.233 17.4969C96.0259 17.4969 94.2365 15.7098 94.2365 13.5051C94.2365 11.3007 96.0259 9.51355 98.233 9.51355C100.44 9.51355 102.229 11.3007 102.229 13.5051C102.229 15.7098 100.44 17.4969 98.233 17.4969ZM98.2309 6.74512C94.493 6.74512 91.4619 9.77198 91.4619 13.5061C91.4619 17.2401 94.493 20.2672 98.2309 20.2672C101.97 20.2672 105.001 17.2401 105.001 13.5061C105.001 9.77198 101.97 6.74512 98.2309 6.74512Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.0198 18.6088C8.36857 18.6088 5.4089 15.6524 5.4089 12.0057C5.4089 8.35878 8.36857 5.40257 12.0198 5.40257V0C5.38136 0 0 5.37506 0 12.0057C0 18.6363 5.38136 24.0114 12.0198 24.0114C18.6582 24.0114 24.0395 18.6363 24.0395 12.0057H18.6306C18.6306 15.6524 15.6708 18.6088 12.0198 18.6088Z" fill="#2354E6"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.0195 12.0074H18.6304V5.4043H12.0195V12.0074Z" fill="#17E6A1"/>
  </g>
  </svg>
  `;

const EditUserName = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.6001" y="12.7998" width="12.8" height="1.6" fill="#04091A" />
    <path
      d="M4.95905 11.1996H2.4001V8.64066L5.52062 5.52013L8.30977 2.73098L10.8687 5.28993L8.07957 8.07909L4.95905 11.1996ZM11.1516 5.00709L11.1512 5.00746L11.1516 5.00709Z"
      stroke="#04091A"
      strokeWidth="1.6"
    />
  </svg>
);

const DownTriangle = () => (
  // <svg
  //   width="20"
  //   height="16"
  //   viewBox="0 0 20 16"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <g opacity="0.95" filter="url(#filter0_bd_2190_12934)">
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M9.2 8.93333C9.6 9.46667 10.4 9.46667 10.8 8.93333L16 2H4L9.2 8.93333Z"
  //       fill="#04091A"
  //       fillOpacity="0.9"
  //     />
  //   </g>
  //   <defs>
  //     <filter
  //       id="filter0_bd_2190_12934"
  //       x="-10"
  //       y="-12"
  //       width="40"
  //       height="35.333"
  //       filterUnits="userSpaceOnUse"
  //       colorInterpolationFilters="sRGB"
  //     >
  //       <feFlood floodOpacity="0" result="BackgroundImageFix" />
  //       <feGaussianBlur in="BackgroundImageFix" stdDeviation="7" />
  //       <feComposite
  //         in2="SourceAlpha"
  //         operator="in"
  //         result="effect1_backgroundBlur_2190_12934"
  //       />
  //       <feColorMatrix
  //         in="SourceAlpha"
  //         type="matrix"
  //         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  //         result="hardAlpha"
  //       />
  //       <feOffset dy="2" />
  //       <feGaussianBlur stdDeviation="2" />
  //       <feColorMatrix
  //         type="matrix"
  //         values="0 0 0 0 0.0156863 0 0 0 0 0.0352941 0 0 0 0 0.0980392 0 0 0 0.4 0"
  //       />
  //       <feBlend
  //         mode="normal"
  //         in2="effect1_backgroundBlur_2190_12934"
  //         result="effect2_dropShadow_2190_12934"
  //       />
  //       <feBlend
  //         mode="normal"
  //         in="SourceGraphic"
  //         in2="effect2_dropShadow_2190_12934"
  //         result="shape"
  //       />
  //     </filter>
  //   </defs>
  // </svg>
  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.2 6.93333C5.6 7.46667 6.4 7.46667 6.8 6.93333L12 0H0L5.2 6.93333Z" fill="#474F66" fillOpacity="0.9" />
  </svg>

);

const SingleBlockShareIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.60005 0.799805C1.15822 0.799805 0.800049 1.15798 0.800049 1.59981V11.1998C0.800049 13.4089 2.59091 15.1998 4.80005 15.1998H14.4C14.8419 15.1998 15.2 14.8416 15.2 14.3998V9.5998H13.6V13.5998H4.80005C3.47457 13.5998 2.40005 12.5253 2.40005 11.1998V2.3998H6.40005V0.799805H1.60005Z" fill="#fff" />
    <path d="M15.2 7.1998H13.6V3.53123L7.36579 9.76549L6.23442 8.63412L12.4687 2.3998H8.80005V0.799805H15.2V7.1998Z" fill="#fff" />
  </svg>
);

const WhiteUpIcon = ({
  type = 'up',
}) => {
  return (
    <div className="white-icon">
      {
        type === 'up' ? (
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.87793 6.06667L7.67793 1.4L12.4779 6.06667H9.59793V12.6H5.75793V6.06667H2.87793Z" fill="white" fillOpacity="0.7" />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7998 7.93333L6.9998 12.6L2.19981 7.93333L5.07981 7.93333L5.07981 1.4L8.91981 1.4L8.91981 7.93333L11.7998 7.93333Z" fill="white" fillOpacity="0.7" />
          </svg>
        )
      }
    </div>
  )
}


export {
  EditUserName,
  DownTriangle,
  CloseIcon,
  CloseXIcon,
  DownIcon,
  KeywordIcon,
  NextIcon,
  NextIconDisable,
  LastIcon,
  ShareTopRightIcon,
  ShareLeftBottomIcon,
  ShareButtonIcon,
  NokeywordIcon,
  LogoIcon,
  LastIconDisable,
  SingleBlockShareIcon,
  WhiteUpIcon,
};
